"use client";

import styles from "./info-tabs.module.scss";

const ReferencesTab = () => {
  return (
    <div className={styles.tabContent}>
      <h2>References</h2>
      <div className={styles.tabUnorderedList}>
        <ul>
          <li id="ref-owen-2007">
            Owen, P., 2007.{" "}
            <i>LIFE and Europe’s Wetlands: Restoring a Vital Ecosystem</i>.
            Office for Official Publications of the European Communities,
            Luxembourg.
          </li>
          <li id="ref-npws-2017">
            NPWS (National Parks and Wildlife Service), 2017.{" "}
            <i>
              National Raised Bog Special Areas of Conservation Management Plan
              2017–2022
            </i>
            . Department of Culture, Heritage and the Gaeltacht, Dublin.
          </li>
          <li id="ref-page-baird">
            Page, S. E. & Baird, A.J. (2016). {" "}
            <i>Peatlands and Global Change: Response and Resilience.</i>
            Annual Review of Environment & Resources. Vol. 41:35-57
          </li>
          <li id="ref-yu-2011">
            Yu, Z., Beilman, D. W., Frolking, S., MacDonald, G.M., Roulet, N. T., 
            Camill P. & Charman, D. J. (2011).{" "}
            <i>Peatlands and Their Role in the Global Carbon Cycle, </i>. Eos Trans. 
            AGU, 92(12), 97.
          </li>
          <li id="ref-schouten-2002">
            Schouten, M.G., 2002.{" "}
            <i>
              Conservation and Restoration of Raised Bogs: Geological,
              Hydrological, and Ecological Studies
            </i>
            . The Government Stationery Office, Dublin.
          </li>
          <li id="ref-gilet-2024">
            Gilet, L., Morley, T., Flynn, R. & Connolly, J. (2024).{" "}
            <i>
              An adaptive mapping framework for the management of peat soils: A new Irish peat soils map
            </i>
            . Geoderma. <strong>447</strong>, 116933.
          </li>

          <li id="ref-regan-2020">
            Regan, S., Swenson, M., O&apos;Connor, M. &amp; Gill, L. (2020).{" "}
            <i>
              Ecohydrology, Greenhouse Gas Dynamics and Restoration Guidelines for Degraded Raised Bogs
            </i>
            . EPA Research Report No. 342.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ReferencesTab;
